var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isShowPage ? _c("div", {
    class: ["openai-detail", {
      "openai-detail-component": _vm.activeTab === "component"
    }]
  }, [_c("section", {
    staticClass: "detail-menu"
  }, [_c("div", {
    staticClass: "detail-menu-con"
  }, [_c("div", {
    staticClass: "menu-box"
  }, [_c("ul", {
    staticClass: "menu-tab"
  }, _vm._l(_vm.tabList, function (item, index) {
    return _c("li", {
      key: index,
      class: {
        active: item.key === _vm.activeTab
      },
      on: {
        click: function ($event) {
          return _vm.changeTab(item.key);
        }
      }
    }, [[_vm._v(_vm._s(item.name))]], 2);
  }), 0)]), _c("div", {
    staticClass: "menu-list"
  }, [_c("v-menu", {
    attrs: {
      tabList: _vm.tabList,
      activeTab: _vm.activeTab
    },
    on: {
      changeCollapsed: _vm.changeCollapsed,
      changeDetail: _vm.changeDetail
    }
  })], 1)])]), _c("section", {
    staticClass: "detail-content"
  }, [_c("transition", {
    attrs: {
      name: "fade-in-linear"
    }
  }, [_vm.activeTab === "component" ? _c("v-component-detail", {
    attrs: {
      _id: _vm.getActiveid("component")
    }
  }) : _c("v-interface-detail", {
    attrs: {
      _groupCode: _vm.interface_groupCode || _vm.getActiveGroupCode("interface"),
      _id: _vm.interface_id || _vm.getActiveid("interface"),
      contentData: _vm.contentData
    },
    on: {
      addOrderList: _vm.addOrderList
    }
  })], 1)], 1), _c("section", {
    staticClass: "order"
  }, [_c("transition", {
    attrs: {
      name: "fade-translateX"
    }
  }, [_vm.showOrderList ? _c("div", {
    ref: "orderList",
    staticClass: "order-list"
  }, [_c("img", {
    staticClass: "icon icon-close",
    attrs: {
      src: require("@/assets/images/icon-close.png"),
      alt: "close"
    },
    on: {
      click: function ($event) {
        return _vm.changeShowOrderList(false);
      }
    }
  }), _c("div", {
    staticClass: "order-content"
  }, [_c("div", {
    staticClass: "order-component"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("意向组件")]), _c("ol", {
    staticClass: "order-component-list"
  }, _vm._l(_vm.orderList.component, function (item, index) {
    return _c("li", {
      key: index
    }, [_c("img", {
      staticClass: "icon",
      attrs: {
        src: require("@/assets/images/service/openAI/icon-component.png"),
        alt: "icon"
      }
    }), _c("span", {
      staticClass: "single"
    }, [_vm._v(_vm._s(item.product_name))]), _c("img", {
      staticClass: "icon icon-remove",
      attrs: {
        src: require("@/assets/images/icon-remove.png"),
        alt: "icon"
      },
      on: {
        click: function ($event) {
          return _vm.removeOrderList(item.product_code);
        }
      }
    })]);
  }), 0)]), _c("div", {
    staticClass: "order-interface"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("意向数据接口")]), _c("ol", {
    staticClass: "order-interface-list"
  }, _vm._l(_vm.orderList.interface, function (item, index) {
    return _c("li", {
      key: index
    }, [_c("img", {
      staticClass: "icon",
      attrs: {
        src: require("@/assets/images/service/openAI/icon-interface.png"),
        alt: "icon"
      }
    }), _c("span", {
      staticClass: "single"
    }, [_vm._v(_vm._s(item.product_name))]), _c("img", {
      staticClass: "icon icon-remove",
      attrs: {
        src: require("@/assets/images/icon-remove.png"),
        alt: "icon"
      },
      on: {
        click: function ($event) {
          return _vm.removeOrderList(item.product_code);
        }
      }
    })]);
  }), 0)])]), _c("button", {
    staticClass: "order-save",
    on: {
      click: _vm.submitOrderList
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("@/assets/images/icon-save.png"),
      alt: "save"
    }
  }), _vm._v(" 生成意向单 ")])]) : _vm._e()])], 1), _vm.showTop ? _c("div", {
    staticClass: "nav-top",
    on: {
      click: _vm.goTop
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/openAI/top1.png"),
      alt: ""
    }
  })]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };